import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorService } from 'src/app/core/services/error.service';
import { CustomAlertService } from 'src/app/core/services/custom-alert.service';
import { ProfileCacheService } from 'src/app/core/services/profile-cache.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../../models/user.model';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    loginForm: UntypedFormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';
    token: any;
    idStation: any;
    creId: any;
    rol;
    showPassword = false;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthService,
        private errorService: ErrorService,
        private customAlert: CustomAlertService,
        private profileCacheService: ProfileCacheService
    ) {
        this.token = localStorage.getItem('token');
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
        this.currentUser = this.currentUserSubject.asObservable();

        if (this.authenticationService.currentUserValue && this.token) {
            this.router.navigate(['/gasprecio/monitor']);
        }
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });

        this.tryAutoLoginFromQuery();
    }

    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.submitted = true;

        if (this.loginForm.invalid) {
            return;
        }

        // Limpiar cachés antes de hacer login
        this.profileCacheService.clearCache();

        this.authenticationService.login(this.f.email.value, this.f.password.value)
            .subscribe({
                next: (data: any) => {
                    console.log(data)
                    this.idStation = data.user.stations[0]._id;
                    this.creId = data.user.stations[0].cre;
                    this.token = data.user.token;
                    this.rol = data.user.rol;
                    data.authdata = window.btoa(this.f.email.value + ':' + this.f.password.value);
                    localStorage.setItem('creId', this.creId);
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    localStorage.setItem('idStation', this.idStation);
                    localStorage.setItem('token', this.token);
                    localStorage.setItem('rol', this.rol);
                    this.currentUserSubject.next(data);
                    this.reloadPage();
                                        }, error: (err) => {
                                                // delegate to error service; if it's a validation object it will reject with details
                                                this.errorService.handle(err).catch(() => {
                                                    // fallback: show generic invalid credentials
                                                    this.customAlert.showError('El usuario o la contraseña son inválidos', 'Inténtalo de nuevo');
                                                });
                                        }
            });
    }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }

    reloadPage(): void {
        window.location.reload();
    }

        // kept for compatibility but now handled by ErrorService / CustomAlertService
        errorLogin() {
            this.customAlert.showError('El usuario o la contraseña son inválidos', 'Inténtalo de nuevo');
        }

    async recoverPassword() {
        const { value: email } = await Swal.fire({
            title: 'Recuperar contraseña',
            text: 'Ingrese su cuenta de correo electrónico y le enviaremos instrucciones para recuperar su contraseña.',
            input: 'email',
            inputPlaceholder: 'Correo electrónico',
            confirmButtonText: 'Enviar',
            confirmButtonColor: '#00e07b'
        });

        if (email) {
            await this.authenticationService.sendRecoverPassword(email);
            Swal.fire({
                title: 'Correo enviado',
                text: `Te hemos enviado un correo a ${email} con las instrucciones para recuperar tu contraseña.`,
                icon: 'success',
                confirmButtonColor: '#00e07b',
                confirmButtonText: 'Aceptar'
            });
        }
    }

    private tryAutoLoginFromQuery(): void {
        const code = this.route.snapshot.queryParamMap.get('code');
        if (!code) return;

        localStorage.clear();

        try {
            // decode base64 → objeto
            const decoded = atob(code);
            const response = JSON.parse(decoded);

            localStorage.setItem('token', response?.user?.token);
            localStorage.setItem('idStation', response?.user?.stations[0]);
            localStorage.setItem('user', JSON.stringify(response.user));

            this.router.navigate(['/gasprecio/monitor']);

        } catch (err) {
            console.error('Auto-login por query param falló:', err);
            // Si falla, se queda el form de login normal
        }
    }
}
